import { commonRoutes } from "@/service/routing/sections/common";
import { vendorRoutes } from "./sections/vendor";
import { subscriptionRoutes } from "./sections/service/subscription";
import { shopRoutes } from "./sections/shop";
import { eventsRoutes } from "./sections/events";
import { discountRoutes } from "@/service/routing/sections/discount";
import { carOfferRoutes } from "@/service/routing/sections/car-offer";
import { videoRoutes } from "@/service/routing/sections/video";
import { insuranceRoutes } from "@/service/routing/sections/service/insurance";
import { serviceRoutes } from "@/service/routing/sections/service/service";

const routes = {
  ...commonRoutes,
  ...vendorRoutes,
  ...subscriptionRoutes,
  ...shopRoutes,
  ...eventsRoutes,
  ...discountRoutes,
  ...carOfferRoutes,
  ...videoRoutes,
  ...insuranceRoutes,
  ...serviceRoutes,
} as const;

export function createPath(
  name: keyof typeof routes | string,
  options: any = {},
): string {
  try {
    const route = routes[name as keyof typeof routes];

    if (typeof route === "function") {
      return route(options);
    }

    return route;
  } catch (e) {
    throw new Error(`${name} doesn't exist in routing, message: ${e}`);
  }
}
